module.exports = __webpack_public_path__ + "media/images/placeholders/feed_placeholder-a3ea78ed071bf7cd6b5d5378545507e3.png";